import { FC } from 'react';
import { Box, Text, Tooltip } from '@mantine/core';
import { IRowData } from '@components/simple-table/types';
import { IPostClientEmail } from '@/entities/admin-app/roles/types';
import { useStyles } from './styles';

interface IMailboxesCellProps {
  item: IRowData;
}

export const MailboxesCell: FC<IMailboxesCellProps> = ({ item }) => {
  const { classes } = useStyles();
  const postClientEmails = item?.PostClientEmails as IPostClientEmail[] | undefined;

  if (!postClientEmails || postClientEmails.length === 0) {
    return <Text c="dimmed">—</Text>;
  }

  const firstServer = postClientEmails[0];
  const firstEmail = firstServer?.Emails?.[0];
  const hasMoreData = postClientEmails.length > 1 || (firstServer?.Emails?.length || 0) > 1;

  const renderTooltipContent = () => {
    return (
      <Box className={classes.tooltipContent}>
        {postClientEmails.map((serverData: IPostClientEmail, serverIndex: number) => (
          <Box key={serverIndex} className={classes.serverBlock}>
            <Text className={classes.serverName}>{serverData.Server}</Text>
            {serverData.Emails.map((email: string, emailIndex: number) => (
              <Text key={emailIndex} className={classes.emailItem}>
                {email}
              </Text>
            ))}
          </Box>
        ))}
      </Box>
    );
  };

  if (!firstEmail) {
    return <Text c="dimmed">—</Text>;
  }

  return (
    <Tooltip
      label={renderTooltipContent()}
      position="bottom-start"
      withArrow
      disabled={!hasMoreData}
      classNames={{
        tooltip: classes.tooltip
      }}
    >
      <Box className={classes.cellContent}>
        <Text className={classes.emailText} lineClamp={1}>
          {firstEmail}
        </Text>
        <Text className={classes.serverText} lineClamp={1}>
          {firstServer.Server}
        </Text>
        {hasMoreData && (
          <Text className={classes.moreIndicator}>
            +
            {postClientEmails.reduce(
              (total: number, server: IPostClientEmail) => total + server.Emails.length,
              0
            ) - 1}
          </Text>
        )}
      </Box>
    </Tooltip>
  );
};
